export default __webpack_public_path__ + "static/es-Children-45eb41e12a340da1f8fe722669d1224b.pdf";